import { Box, Container, Heading, Text, VStack, SimpleGrid, List, ListItem, ListIcon, Button, Flex } from "@chakra-ui/react";
import { FaCheckCircle, FaWrench, FaUserTie, FaMapPin } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { NavbarWithCallToAction } from "../../components/chakra/NavbarWithCallToAction/NavbarWithCallToAction";
import { FooterWithFourColumns } from "../../components/chakra/FooterWithFourColumns/FooterWithFourColumns";
import { getColor } from "../../brandConfig";

const SolarRepairsPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <NavbarWithCallToAction />
      <Box bg={getColor("background.main")} minHeight="100vh">
        <Box position="relative" width="100vw" height="500px" overflow="hidden" marginLeft="50%" transform="translateX(-50%)" backgroundImage="url('/assets/onesolarimages/0002_solar-repairs-professional.jpg')" backgroundSize="cover" backgroundPosition="center">
          <Box position="absolute" top={0} left={0} right={0} bottom={0} bg="rgba(0, 0, 0, 0.5)" zIndex={1} />
          <Container maxW="1200px" position="relative" zIndex={2} height="100%" display="flex" alignItems="center">
            <VStack spacing={6} align="flex-start" maxW="800px">
              <Heading as="h1" fontSize={{ base: "4xl", md: "5xl", lg: "6xl" }} fontWeight="bold" color="white" textShadow="2px 2px 4px rgba(0,0,0,0.5)" fontFamily="'Open Sans', sans-serif" textTransform="uppercase">Solar Repairs</Heading>
              <Text fontSize={{ base: "lg", md: "xl" }} color="white" textShadow="2px 2px 4px rgba(0,0,0,0.5)" fontFamily="'Open Sans', sans-serif">We Can Diagnose and Repair Your Solar System</Text>
              <Button size="lg" bg="white" color="#121c47" px={8} py={6} fontSize="md" fontWeight="600" textTransform="uppercase" borderRadius="4px" fontFamily="'Open Sans', sans-serif" _hover={{ bg: "gray.100" }} onClick={() => navigate("/contact")}>Get Repair Quote</Button>
            </VStack>
          </Container>
        </Box>

        <Box bg="white" py={{ base: 16, md: 20 }}>
          <Container maxW="1200px">
            <VStack spacing={16} align="stretch">
              <Box>
                <Box width="60px" height="2px" bg="#121c47" mb={4} />
                <Heading as="h2" fontSize={{ base: "2xl", md: "3xl" }} fontWeight="bold" color="#050303" fontFamily="'Open Sans', sans-serif" mb={6}>Expert Solar System Repairs</Heading>
                <Text fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif" lineHeight="1.8">We can diagnose and repair your solar system regardless of the original installer. Our team works to restore systems to maximum operational performance, ensuring you get the most from your solar investment.</Text>
              </Box>

              <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8}>
                <Box textAlign="center" p={6} bg="#f8f9fa" borderRadius="lg">
                  <FaUserTie size={50} color="#121c47" style={{ margin: '0 auto 1rem' }} />
                  <Heading as="h3" fontSize="lg" fontWeight="bold" color="#050303" fontFamily="'Open Sans', sans-serif" mb={3}>Professional</Heading>
                  <Text fontSize="md" color="#666" fontFamily="'Open Sans', sans-serif">CEC-accredited, insured technicians providing confidence in system repairs</Text>
                </Box>
                <Box textAlign="center" p={6} bg="#f8f9fa" borderRadius="lg">
                  <FaWrench size={50} color="#121c47" style={{ margin: '0 auto 1rem' }} />
                  <Heading as="h3" fontSize="lg" fontWeight="bold" color="#050303" fontFamily="'Open Sans', sans-serif" mb={3}>Experienced</Heading>
                  <Text fontSize="md" color="#666" fontFamily="'Open Sans', sans-serif">Encountered practically every type of issue in solar systems</Text>
                </Box>
                <Box textAlign="center" p={6} bg="#f8f9fa" borderRadius="lg">
                  <FaMapPin size={50} color="#121c47" style={{ margin: '0 auto 1rem' }} />
                  <Heading as="h3" fontSize="lg" fontWeight="bold" color="#050303" fontFamily="'Open Sans', sans-serif" mb={3}>Local</Heading>
                  <Text fontSize="md" color="#666" fontFamily="'Open Sans', sans-serif">Understanding of regional solar issues and tailored solutions</Text>
                </Box>
              </SimpleGrid>

              <Box>
                <Heading as="h3" fontSize={{ base: "xl", md: "2xl" }} fontWeight="bold" color="#050303" fontFamily="'Open Sans', sans-serif" mb={6}>Common Issues We Fix</Heading>
                <List spacing={4}>
                  {[
                    { title: 'Smashed Panels', desc: 'Weather or debris damage requiring panel replacement' },
                    { title: 'Microcracks', desc: 'Long-term performance decline from panel degradation' },
                    { title: 'Hotspots', desc: 'Voltage overload or manufacturing defects' },
                    { title: 'Inverter Malfunctions', desc: 'System failures requiring inverter repairs or replacement' },
                    { title: 'Corrosion & Worn Components', desc: 'Age-related issues affecting performance' },
                    { title: 'Compliance Modifications', desc: 'Updates to meet current regulatory standards' }
                  ].map((item, i) => (
                    <ListItem key={i}>
                      <Flex align="flex-start">
                        <ListIcon as={FaCheckCircle} color="#121c47" mt={1} boxSize={5} />
                        <Box>
                          <Text fontSize={{ base: "md", md: "lg" }} fontWeight="600" color="#050303" fontFamily="'Open Sans', sans-serif">{item.title}</Text>
                          <Text fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">{item.desc}</Text>
                        </Box>
                      </Flex>
                    </ListItem>
                  ))}
                </List>
              </Box>

              <Box bg="#121c47" color="white" p={{ base: 8, md: 12 }} borderRadius="lg" textAlign="center">
                <Heading as="h3" fontSize={{ base: "xl", md: "2xl" }} fontWeight="bold" fontFamily="'Open Sans', sans-serif" mb={4}>Need Solar Repairs?</Heading>
                <Text fontSize={{ base: "md", md: "lg" }} fontFamily="'Open Sans', sans-serif" mb={6}>Contact us today for a comprehensive diagnostic and repair quote. We'll get your system back to peak performance.</Text>
                <Button size="lg" bg="white" color="#121c47" px={8} py={6} fontSize="md" fontWeight="600" textTransform="uppercase" borderRadius="4px" fontFamily="'Open Sans', sans-serif" _hover={{ bg: "gray.100" }} onClick={() => navigate("/contact")}>Schedule Repair</Button>
              </Box>
            </VStack>
          </Container>
        </Box>
        <FooterWithFourColumns />
      </Box>
    </>
  );
};

export default SolarRepairsPage;
